import {loadLib} from "../../utils/loadLib";

window.VegasCatalog = {
	popup: function (text, params = {}) {
		let defaults = {
			"positionClass": "toast-bottom-center",
			'preventDuplicates': true,
		};

		loadLib.toastr().then((Toastr) => {
			Toastr.options = Object.assign(defaults, params);
			Toastr.success(text);
		});
	}
};

require('./_function');
require('./_product');
require('./_collection');
require('./_cart');
require('./_compare');
require('./_fav');
require('./order/order');
require('./filters/filters');
require('./_input-counter');
require('./_selector');
